module.exports = {
	userinfo: {}
};


// WEBPACK FOOTER //
// ./src/store/userinfo/state.js